// src/components/phases/PresentationPhase.js
import React, { memo } from 'react';
import './PresentationPhase.css';

/**
 * PresentationPhase Component
 * Displays the presentation phase UI where Judge presents submissions one by one
 */
const PresentationPhase = memo(
  ({ presentationState, isJudge, judgeUsername, onStartPresentation, onNextSubmission }) => {
    console.log('🎭 PresentationPhase component rendered');
    console.log('🎭 Presentation state:', presentationState);

    // Show start presentation UI when isActive is true but currentIndex is -1
    if (presentationState.isActive && presentationState.currentIndex === -1) {
      return (
        <div className="presentation-phase">
          <div className="presentation-waiting">
            <h3>🎭 Ready to Present Submissions</h3>
            <p>All players have submitted their cards!</p>
            {isJudge ? (
              <div className="czar-controls">
                <p>
                  As the Judge, you'll present each submission one by one to create suspense and
                  laughter!
                </p>
                <button onClick={onStartPresentation} className="btn btn-primary presentation-btn">
                  🎭 Start Presentation
                </button>
              </div>
            ) : (
              <p>Waiting for {judgeUsername} to start the presentation...</p>
            )}
          </div>
        </div>
      );
    }

    // Individual submission presentation
    if (presentationState.currentIndex >= 0 && !presentationState.showAllSubmissions) {
      const currentSubmission = presentationState.currentSubmission;

      return (
        <div className="presentation-phase">
          <div className="presentation-header">
            <h3>🎭 Presenting Submissions</h3>
            <div className="presentation-counter">
              Submission {presentationState.currentIndex + 1} of{' '}
              {presentationState.totalSubmissions}
            </div>
          </div>

          <div className="current-presentation">
            {currentSubmission && (
              <div className="presented-submission">
                <div className="submission-header">
                  <h4>🎩 Anonymous Submission</h4>
                </div>
                <div className="submission-cards">
                  {(currentSubmission.cards || []).map((card, cardIndex) => (
                    <div key={cardIndex} className="submitted-card">
                      <div className="card-content">
                        {typeof card === 'string' ? card : card?.text || 'Invalid card'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {isJudge && (
            <div className="czar-controls">
              <button onClick={onNextSubmission} className="btn btn-primary presentation-btn">
                {presentationState.currentIndex + 1 < presentationState.totalSubmissions
                  ? '▶️ Next Submission'
                  : '🎆 Show All & Vote'}
              </button>
            </div>
          )}

          {!isJudge && (
            <div className="spectator-message">
              <p>🎭 Enjoy the show! Judge is presenting each submission...</p>
            </div>
          )}
        </div>
      );
    }

    return null;
  }
);

export default PresentationPhase;
